module.exports = __webpack_public_path__ + "fonts/CeraPro-Light.a55a844.woff";